export const GET_MODELS_BY_BRNAD_REQUEST = "GET_MODELS_BY_BRNAD_REQUEST";
export const GET_MODELS_BY_BRNAD_SUCCESS = "GET_MODELS_BY_BRNAD_SUCCESS";
export const GET_MODELS_BY_BRNAD_FAILURE = "GET_MODELS_BY_BRNAD_FAILURE";
